import React from "react";

const Header = ({data}) => {
  return (
  <div clas="flex w-[100%] gap-3">
    {/* 좌상단 */}
    <div clas="flex-col flex lg:w-[45%]">
      <div clas="font-bold text-2xl min-h-20 content-center">거래명세서</div>
      <div clas="border px-6 text-sm min-h-20 border-black content-center whitespace-pre-wrap">{`자화전자(주) 貴 中\n충청북도 청주시 청원구 북이면 충청대로 1217`}</div>
    </div>
    {/* 우상단 */}
    <div className="flex border min-h-40 border-black flex-grow text-[9.3px]">
      <div className="border border-black [writing-mode:vertical-lr]">공급자</div>
      <div className="flex flex-col flex-grow">
        <div className="flex border border-black h-[15%]">
          <div className="w-[25%] border-r border-black content-center">일련번호</div>
          <div className="w-[25%] border-r border-black content-center">{data.no}</div>
          <div className="w-[25%] border-r border-black content-center">TEL</div>
          <div className="w-[25%] content-center">{data.tel}</div>
        </div>
        <div className="flex border border-black h-[30%]">
          <div className="px-4 w-[25%] border-r border-black content-center whitespace-pre-wrap">{`사업자등록\n번호`}</div>
          <div className="px-2 w-[25%] border-r border-black content-center">{data.businessNum}</div>
          <div className="w-[25%] border-r border-black content-center">성명</div>
          <div className="w-[25%] border-black content-center">{data.name}</div>
        </div>
        <div className="flex border border-black h-[25%]">
          <div className="w-[25%] border-r border-black content-center">상호</div>
          <div className="w-[75%] flex-grow content-center">{data.companyName}</div>
        </div>
        <div className="flex border border-black h-[30%]">
          <div className="w-[25%] border-r border-black content-center">주소</div>
          <div className="w-[75%] flex-grow content-center">{data.address}</div>
        </div>
      </div>
    </div>
  </div>
  )
  
}

export default Header;